module.exports = __webpack_public_path__ + "img/FullCover_Eng2.e3822770.jpg";